const RU = {
    "": "",
    "—": "—",
    "%": "%",
    "°": "°",
    "°C": "°C",
    "1": "1",
    "2": "2",
    "3": "3",
    aboutAccount: "Об аккаунте",
    aboveAverage: "Выше среднего",
    accelerometerAmp: "Чувствительность датчика движения",
    trackerModeAttention: "В режиме трекера расход батареи увеличен!",
    accelerometerAmpTooltip:
        "Чем выше чувствительность датчика, тем ниже порог интенсивности движения, необходимый для отправки сообщения",
    action: "Действие",
    active: "Активен",
    activeAlarms: "Включенные будильники",
    activeServers: "Активные сервера",
    add: "Добавить",
    addDevice: "Добавить устройство",
    addDeviceInDb: "Добавить новое устройство в базу данных",
    addDeviceInOldDb: "Ошибка добавления аккаунта",
    addDeviceInOldDbSuccess: "Успешная активация аккаунта Вега-М",
    addDevicesTitle: "Добавить устройства",
    addDeviceToGroup: "Добавить в группу",
    addDeviceTitle: "Добавить устройство",
    addDeviceToSubuserAccount: "Добавить устройство в аккаунт пользователя",
    addDeviceToSubuserTitle: "Добавление устройства в аккаунт пользователя",
    addGroup: "Создать группу",
    addGroupTitle: "Создание новой группы",
    additionally: "Дополнительно",
    addObject: "Добавить объект",
    address: "Адрес",
    addSubuserTitle: "Создание нового пользователя",
    advancedGnssReceiverSetup: "Дополнительная настройка ГНСС приемника",
    advancedSettings: "Расширенные настройки",
    agree: "Согласен",
    alarm: "Будильник",
    alarm_1: "Будильник №1",
    Alarm_1: "Будильник №1",
    ALARM_1: "Будильник №1",
    alarm_2: "Будильник №2",
    Alarm_2: "Будильник №2",
    ALARM_2: "Будильник №2",
    alarm_3: "Будильник №3",
    Alarm_3: "Будильник №3",
    ALARM_3: "Будильник №3",
    alarm_4: "Будильник №4",
    Alarm_4: "Будильник №4",
    ALARM_4: "Будильник №4",
    alarm_5: "Будильник №5",
    Alarm_5: "Будильник №5",
    ALARM_5: "Будильник №5",
    alarm_6: "Будильник №6",
    Alarm_6: "Будильник №6",
    ALARM_6: "Будильник №6",
    alarm1: "Будильник №1",
    alarm2: "Будильник №2",
    alarm3: "Будильник №3",
    alarm4: "Будильник №4",
    alarm5: "Будильник №5",
    alarm6: "Будильник №6",
    allGroups: "Все группы",
    altitude: "Высота",
    alwaysEnabled: "Включен всегда",
    animal: "Животное",
    animalKind: "Вид животного",
    animalName: "Кличка животного",
    applyToOtherDevices: "Применить к другим устройствам",
    authentication: "Вход в личный кабинет",
    authError: "Ошибка авторизации",
    authMainText: "Функциональный GPS мониторинг для бизнеса и не только",
    authenticationOld: "Импортирование старых аккаунтов",
    back: "Назад",
    backToAuth: "Назад на страницу авторизации",
    batteryCharge: "Заряд батареи",
    batteryState: "Состояние батареи",
    batteryVoltage: "Напряжение батареи",
    belowAverage: "Ниже среднего",
    birthYear: "Год рождения",
    bootVer: "Версия загрузчика",
    bootVerError: "Некорректное значение версии загрузчика",
    brand: "Марка",
    bulkAddDevices: "Массовое добавление устройств",
    callbackPhoneNumber: "Контактный телефон",
    cancel: "Отмена",
    car: "Автомобиль",
    carBrand: "Марка автомобиля",
    carModel: "Модель автомобиля",
    carNumber: "Гос. номер автомобиля",
    carVin: "VIN автомобиля",
    cell_id: "Cell ID",
    changeSettingsShort: "Изменение настроек",
    changeSettings: "Право на изменение настроек устройства",
    changeSubuserPassword: "Изменить пароль пользователя",
    charge: "Заряд",
    close: "Закрыть",
    closeTelemetry: "Закрыть данные телеметрии",
    color: "Цвет",
    company: "Организация",
    companyTaxpayerNumber: "ИНН организации",
    confirm: "Подтвердить",
    confirmationCode: "Код подтверждения",
    confirmationErr: "При подтверждении регистрации произошла ошибка",
    confirmationHasBeenSended: "Код подтверждения был отправлен на почту",
    confirmationHasBeenSendedAgain:
        "Код подтверждения был повторно отправлен на почту",
    confirmDeviceDeleteWarning: "Вы точно хотите удалить устройство",
    confirmGroupDeleteWarning: "Вы точно хотите удалить группу",
    confirmGroupDeleteWarningText:
        "Устройства, которые находятся в группе будут перемещены в группу по умолчанию",
    confirmPageTitle: "Регистрация подтверждена",
    confirmPasswordSuccess: "Пароль был успешно изменен",
    confirmPasswordSuccessTitle: "Пароль восстановлен",
    confirmSettingsClose:
        "У вас есть несохраненные изменения в настройках, вы действительно хотите закрыть настройки без сохранения?",
    confirmSubuserDeleteWarning: "Вы точно хотите удалить пользователя",
    confirmSuccess: "Вы были успешно зарегистрированы в системе",
    confirmText:
        "Введите код подтверждения, отправленный Вам на электронную почту",
    confirmTitle: "Подтверждение регистрации",
    connectionState: "Состояние связи с устройством",
    contactTime: "Время выхода на связь",
    content: "Содержание",
    contractDate: "Дата договора",
    contractNumber: "Номер договора",
    control: "Управление",
    cookiesPolicyAcceptance: "Этот сайт использует cookies для своей работы.",
    coordinateTransmissionPeriod: "Период передачи координат",
    coordinateTransmissionPeriodHelper: "В минутах от 0 до 10",
    coordinateTransmissionPeriodMin: "Период передачи координат, мин",
    coords: "Координаты",
    coordsCopied: "Координаты скопированы",
    coordsGPS: "Координаты GPS",
    coordsLBS: "Координаты LBS",
    coordTime: "Время получения координат",
    coordTxPeriodError: "Период должен быть от 0 до 10 минут",
    coordTxPeriodTooltip:
        "Период передачи координат устройством на сервер, в минутах (от 0 до 10 минут)",
    coordType: "Тип координат",
    copied: "Скопировано",
    create: "Создать",
    createSubuser: "Создать пользователя",
    cur_sim: "Используемая SIM",
    currentState: "Текущее состояние",
    customDate: "Произвольный диапазон дат",
    darkDetect: "Пропадание света",
    DarkDetect: "Пропадание света",
    dataTransmission: "Передача данных",
    date: "Дата",
    datePickerTitle: "Выберите дату",
    default: "По умолчанию",
    deleteSubuser: "Удаление пользователя",
    deliveryDate: "Дата поставки оборудования",
    demo: "Демо",
    demoModeError: "Невозможно в демо-режиме",
    determineCoordinatesByBaseStations:
        "Определить координаты по базовым станциям",
    determineCoordinatesBySatellites: "Определить координаты по спутникам",
    device: "Устройство",
    deviceAlreadyExistError:
        "Устройство уже было добавлено",
    deviceAlreadyExistInDbError: "Устройство уже было добавлено в базу данных",
    deviceContactedToday: "Устройство выходило на связь сегодня",
    deviceDelete: "Удалить устройство",
    deviceIcon: "Иконка устройства",
    deviceIsMoving: "Устройство движется",
    deviceIsStationary: "Устройство не движется",
    deviceName: "Имя устройства",
    deviceNameError: "Введите имя устройства",
    deviceNameTooltip:
        "Имя под которым устройство будет отображаться в списке устройств",
    deviceNotContactedFor3days: "Устройство не выходило на связь более 3 суток",
    deviceNotContactedFor24hours:
        "Устройство не выходило на связь более 24 часов",
    deviceNotContactedToday: "Устройство не выходило на связь сегодня",
    deviceNotContactedYet: "Устройство ещё не выходило на связь",
    devicePasswordTooltip:
        "Пароль для доступа к устройству",
    devices: "Устройства",
    deviceSettings: "Настройки устройства",
    deviceSettingsTitle: "Настройки устройства",
    deviceSettingsUnavailableAlert:
        "Настройки устройства станут доступны при первом выходе устройства на связь",
    devicesNumber: "Количество устройств",
    devicesNumberLongTimeNoContact:
        "Количество устройств не выходящих на связь более 3 дней",
    devicesNumberNoTelemetry: "Количество устройств без телеметрии",
    devicesNumberWithLowCharge: "Количество устройств с зарядом менее 25%",
    deviceTimezoneTooltip: "Часовой пояс устройства",
    deviceType: "Тип устройства",
    deviceTypeTooltip: "Тип объекта на который установлен маяк",
    deviceTz: "Часовой пояс устройства",
    dir: "Курс",
    disabled: "Отключен",
    disabled1: "Отключена",
    displayGroupOnTheMap: "Отобразить группу на карте",
    dnsAddress: "Адрес DNS сервера",
    dnsAddressTooltip: "IP-адрес DNS-сервера",
    download: "Скачать",
    downloadTemplate: "Скачать шаблон",
    editDeviceDescription: "Изменить описание устройства",
    editDeviceDescriptionTitle: "Редактирование описания устройства",
    editGroupDescription: "Изменить описание группы",
    editGroupDescriptionTitle: "Редактирование описания группы",
    editGroupNameHelperText:
        "Имя группы не должно совпадать с именем другой существующей группы",
    editing: "Редактирование",
    editSubuserDescription: "Изменить пароль пользователя",
    editSubuserRights: "Измененить права пользователя на устройство",
    editSubuserRightsTitle: "Изменение прав на устройство",
    editSubuserTitle: "Изменение пароля пользователя",
    email: "Email",
    emailAlertMessage: "Email должен содержать символ '@' и точку",
    emptyPasswordError: "Введите пароль",
    emptyTypeError: "Введите тип устройства",
    enabled: "Включен",
    enabled1: "Включена",
    error: "Ошибка",
    event: "Событие",
    FIRST_START: "Старт системы",
    firststart: "Старт системы",
    firstStart: "Старт системы",
    FirstStart: "Старт системы",
    from25to50per: "От 25% до 50%",
    fromDate: "От",
    fromSubuser: "У пользователя",
    ftpAddress: "Адрес",
    ftpAddressTooltip: "IP-адрес, или доменное имя FTP-сервера обновлений",
    ftpDirectory: "Директория",
    ftpDirectoryTooltip:
        "Директория в которой находится файл с обновлением на FTP-сервере",
    ftpFilename: "Имя файла",
    ftpFilenameTooltip: "Имя файла с обновлением",
    ftpLogin: "Логин",
    ftpLoginTooltip: "Логин для доступа к FTP-серверу обновлений",
    ftpPassword: "Пароль",
    ftpPasswordTooltip: "Пароль для доступа к FTP-серверу обновлений",
    ftpPort: "Порт",
    ftpPortTooltip: "TCP порт FTP-сервера обновлений",
    fullName: "ФИО",
    fullNameOfInstallingEmployee: "ФИО сотрудника установившего трекер",
    generateReport: "Сформировать отчет",
    gnssMaxSearchTime: "Максимальное время работы",
    gnssMaxSearchTime1: "Максимальное время работы ГНСС приемника",
    gnssMaxSearchTimeError: "Некорректное значение",
    gnssMaxSearchTimeHelper: "От 5 до 15 минут",
    gnssMaxSearchTimeTooltip:
        "Максимальное время работы ГНСС приемника, в минутах",
    gnssMinSearchTime: "Минимальное время работы в режиме энергосбережения",
    gnssMinSearchTimeError: "Некорректное значение",
    gnssMinSearchTimeHelper: "От 60 до 180 секунд с шагом 10 секунд",
    gnssMinSearchTimeInPowersave:
        "Минимальное время работы ГНСС приемника в режиме энергосбережения",
    gnssMinSearchTimeTooltip:
        "Время работы ГНСС приемника в режиме энергосбережения, в секундах",
    gnssPowersave: "Режим энергосбережения",
    gnssPowersaveTooltip:
        "Когда включен режим энергосбережения время работы ГНСС приемника ограничено",
    gnssRectificationTime: "Время уточнения координат",
    gnssRectificationTimeHelper: "В секундах",
    gnssRectificationTimeTooltip:
        "Максимальное время определение координат, в секундах",
    gps: "GPS",
    gpsCoords: "Координаты GPS",
    gpsTime: "Время сбора данных GPS",
    group: "Группа",
    groupDelete: "Удалить группу",
    groupName: "Имя группы",
    groupNameHelperText:
        "Имя группы не должно совпадать с именем существующей группы",
    groups: "Группы",
    groupSettings: "Настройки группы",
    groupsNumber: "Количество групп",
    groupTooltip: "Группа в которую будет добавлено устройство",
    hdop: "HDOP",
    hide: "Скрыть",
    hideAll: "Скрыть все",
    hideSideBar: "Скрыть меню",
    hideTelemetry: "Скрыть данные телеметрии",
    high: "Высокая",
    human: "Человек",
    hwVer: "Версия оборудования",
    hwVerError: "Некорректное значение версии оборудования",
    ignoreHelperText: "от 00:00 до 12:00",
    ignoreTimeTooltip:
        "Время в течении которого будет отключен датчик движения, после его срабатывания",
    imei: "IMEI",
    imeiError: "Введен некорректный IMEI",
    imeiNotExistError: "Устройство с данным IMEI не зарегистрировано в системе",
    imeiTooltip:
        "IMEI - уникальный идентификатор устройства (нанесен на корпус устройства)",
    importOldDevices: "Импортировать Вега-М",
    incorrectData: "Некорректные данные",
    incorrectFile: "Некорректный файл",
    indicators: "Индикаторы",
    infoAboutDevice: "Информация об устройстве",
    inputConfirmationCode: "Введите код подтверждения",
    inputEmailForRecovery:
        "Введите адрес электронной почты для восстановления пароля",
    inputGroupName: "Введите имя группы",
    inputLogin: "Введите логин",
    inputNameOrImei: "Введите имя либо IMEI",
    inputPassword: "Введите пароль",
    installationDate: "Дата установки",
    installingPlace: "Место установки",
    internetAccess: "Доступ в интернет",
    internetSettings: "Настройки интернета",
    inventoryNumber: "Инвентаризационный номер",
    jobTitle: "Должность",
    "km/h": "км/ч",
    lac: "LAC",
    language: "Язык",
    last3Days: "Последние 3 суток",
    last24Hours: "Последние 24 часа",
    lastConnection: "Последний выход на связь",
    lastLocation: "Последнее местоположение",
    lastWeek: "Последняя неделя",
    latitude: "Широта",
    lbs: "LBS",
    lbsCoords: "Координаты LBS",
    lbsTime: "Время сбора данных LBS",
    ledIndication: "Световая индикация",
    ledIndicationTooltip: "Состояние световой индикации на корпусе устройства",
    lessThan25per: "Меньше 25%",
    LIGHT_DISAPPEARANCE: "Пропадание света",
    lightappearance: "Появление света",
    lightDetect: "Появление света",
    LightDetect: "Появление света",
    lightdisappearance: "Пропадание света",
    LIGTH_APPEARANCE: "Появление света",
    link: "Ссылка",
    loading: "Загрузка",
    locationHistory: "История местоположений",
    login: "Логин",
    logOut: "Выход",
    longitude: "Долгота",
    longPeriodAttention:
        "Внимание! Время сна рекомендуется устанавливать до 1 дня",
    low: "Низкая",
    m: "м",
    mainSim: "Основная SIM-карта",
    mainSimTooltip:
        "SIM-карта с помощью которой устройство пытается выйти на связь в первую очередь",
    manufactureYear: "Год выпуска",
    map: "Карта",
    mcc: "MCC",
    medium: "Cредняя",
    min: "мин",
    minute: "Минута",
    minutes: "Минут",
    missing: "Отсутствует",
    mnc: "MNC",
    mode: "Режим",
    model: "Модель",
    modeTooltip_0: "Трекер — устройство постоянно находится на связи",
    modeTooltip_1:
        "Периодический — устройство выходит на связь в соответствии с периодичностью указанной в настройках",
    modeTooltip_2:
        "Будильник — устройство выходит на связь в заранее определенное время",
    monitoring: "Мониторинг",
    more: "Подробнее",
    moreThan50per: "Более 50%",
    MOTION_DETECT: "Начало движения",
    motiondetect: "Начало движения",
    motionSensor: "Датчик движения",
    motionAngleSensor: "Датчик движения / наклона",
    motionSensorIgnoreTime:
        "Время игнорирования датчика движения после срабатывания",
    motionSensorIgnoreTimeError:
        "Некорректное время игнорирования датчика движения после срабатывания",
    motionSensorModesTooltip_0:
        "Отключен — датчик движения отключен (устройство не реагирует на движение)",
    motionSensorModesTooltip_1: `Включен всегда — датчик движения включен (при фиксации движения,
                                интенсивность которого превышает заданный порог, устройство отправит свои координаты)
                `,
    motionSensorModesTooltip_2: `Работает в периоде — датчик движения включен в указанный период суток`,
    motionSensorPeriodEnd: "Конец периода работы датчика движения",
    motionSensorPeriodStart: "Начало периода работы датчика движения",
    move: "Датчик движения",
    Move: "Датчик движения",
    movementState: "Состояние движения",
    moveToAnotherGroup: "Переместить в другую группу",
    name: "Имя",
    no: "Нет",
    noAlarmsEnabled: "Не включен ни один будильник",
    noData: "Нет данных",
    noDataAboutBattery: "Нет данных о состоянии батареи",
    noDataAboutMovementStatus: "Нет данных о состоянии движения устройства",
    noDevices: "Нет устройств",
    noRightsDeviceSettingsError:
        "Недостаточно прав для редактирования настроек",
    noRightsError:
        "Недостаточно прав для добавления устройства в выбранную группу",
    noSettingsError: "Настройки ещё не получены",
    notActive: "Не активен",
    notExist: "#Что-то",
    notExistError: "Пользователь с таким Email не зарегистрирован",
    notToIgnore: "Не игнорировать",
    notToIgnoreTooltip: "Датчик движения не отключается после его срабатывания",
    ntpAddress: "Адрес NTP-сервера",
    ntpAddressTooltip: "IP-адрес, или доменное имя NTP-сервера",
    ntpPort: "Порт NTP-сервера",
    ntpPortTooltip: "TCP порт NTP-сервера",
    number: "№ п/п",
    objectType: "Тип объекта",
    of: "Из",
    ok: "OK",
    openTelemetry: "Открыть данные телеметрии",
    operationMode: "Режим работы",
    option: "Параметр",
    options: "Параметры",
    or: "Или",
    password: "Пароль",
    passwordAlertMessage: "Пароль должен содержать не менее 8 символов",
    passwordConfirm: "Подтверждение пароля",
    passwordConfirmAlertMessage: "Пароли должны совпадать",
    passwordRecover: "Восстановить пароль",
    passwordRecovery: "Восстановление пароля",
    passwordRecoveryConfirm: "Подтверждение восстановление пароля",
    periodEnd: "Конец периода",
    periodEndTooltip:
        "Время суток (в соответствии с часовым поясом устройства) в которое прекращает работать датчик движения устройства",
    periodic: "Периодический",
    Periodic: "Периодический",
    PERIODIC: "Периодическое сообщение",
    periodicActiveTime: "Время ожидания команд",
    periodicActiveTimeError: "Время должно быть от 3 до 15 минут",
    periodicActiveTimeHelper: "От 3 до 15 минут",
    periodicActiveTimeMin: "Время ожидания команд, мин",
    periodicActiveTimeTooltip:
        "Время, в минутах, в течении которого устройство будет ожидать команды после выхода на связь (от 3 до 15 минут)",
    periodicallyEnabled: "Работает в периоде",
    periodicLocationPeriod: "Период определения координат ",
    periodicLocationPeriodError: "Значение должно быть больше 1",
    periodicLocationPeriodHelper:
        "Количество сеансов связи до следующего определения координат",
    periodicSleepDaysError: "Должно быть от 0 до 30",
    periodicSleepHoursError: "Должно быть от 0 до 23",
    periodicSleepMinutesError: "Должно быть от 0 до 59",
    periodicSleepTime: "Время сна",
    periodicSleepTimeDays: "Дни",
    periodicSleepTimeDaysHelper: "От 0 до 30 суток",
    periodicSleepTimeDaysTooltip:
        "Количество дней, в течении которого устройство будет находится в режиме сна после завершения сеанса связи (от 0 до 30 суток)",
    periodicSleepTimeError: "Минимальное время сна ‒ 1 минута",
    periodicSleepTimeHelper: "От 1 до 1440 минут",
    periodicSleepTimeHours: "Часы",
    periodicSleepTimeHoursHelper: "От 0 до 23 часов",
    periodicSleepTimeHoursTooltip:
        "Количество часов, в течении которого устройство будет находится в режиме сна после завершения сеанса связи (от 0 до 23 часов)",
    periodicSleepTimeMin: "Время сна, мин",
    periodicSleepTimeMinutes: "Минуты",
    periodicSleepTimeMinutesHelper: "От 0 до 59 минут",
    periodicSleepTimeMinutesTooltip:
        "Количество минут, в течении которого устройство будет находится в режиме сна после завершения сеанса связи (от 0 до 59 минут)",
    periodicSleepTimeTooltip:
        "Время, в минутах, в течении которого устройство будет находится в режиме сна после завершения сеанса связи (от 1 до 1440 минут)",
    periodStart: "Начало периода",
    periodStartAndEndError:
        "Начало и конец периода работы датчика движения не должны быть одинаковыми",
    periodStartTooltip:
        "Время суток (в соответствии с часовым поясом устройства) в которое начинает работать датчик движения устройства",
    phoneNumSim1: "Номер телефона для отправки с SIM 1",
    phoneNumSim1Tooltip:
        "Номер телефона на который будут отправляться данные с SIM 1",
    phoneNumSim2: "Номер телефона для отправки с SIM 2",
    phoneNumSim2Tooltip:
        "Номер телефона на который будут отправляться данные с SIM 2",
    pm: "Периодический режим",
    port: "Порт",
    present: "Присутствует",
    privacyPolicy: "Политика обработки ПДн",
    privacyPolicy_1: "(Политика обработки)",
    privacyPolicyAcceptance_1: "персональных данных",
    privacyPolicyAcceptance: "Вы даете согласие на обработку",
    privacyPolicyError: "Не получено согласие на обработку персональных данных",
    protocol: "Протокол",
    recover: "Восстановить",
    recoverThePassword: "Восстановить пароль",
    registerError: "Пользователь с таким Email уже зарегистрирован",
    registration: "Регистрация",
    report: "Отчет",
    reports: "Отчеты",
    requestAgain: "Запросить снова",
    resetSettings: "Сбросить настройки",
    rowsPerPage: "Записей на странице",
    s: "с",
    satellitesNumber: "Количество спутников",
    save: "Сохранить",
    saveAlertMessage: "Настройки были успешно сохранены",
    saveDescriptionAlertMessage: "Описание было успешно изменено",
    saveDeviceAdding: "Устройство успешно добавлено",
    selectGroupToMoveInDevice:
        "Выберите группу, в которую хотите переместить устройство",
    send: "Отправить",
    sendCommandsShort: "Отправка команд",
    sendCommands: "Право на отправку команд на устройство",
    sensorIgnoreTime: "Время игнорирования после срабатывания",
    server1: "Сервер №1",
    server2: "Сервер №2",
    server3: "Сервер №3",
    serverAddress: "Адрес сервера",
    serverAddressTooltip: "IP-адрес, или доменное имя сервера",
    serverError: "Ошибка сервера",
    serverPassword: "Пароль",
    serverPasswordTooltip: "Пароль для доступа к серверу",
    serverPort: "Порт",
    serverPortTooltip:
        "TCP порт по которому должен происходить обмен данными устройства с сервером",
    serverProtocolTooltip:
        "Протокол обмена данными между сервером и устройством",
    serverStateTooltip: "Отправлять данные через интернет на",
    setComputerTimezone: "Установить часовой пояс компьютера",
    settings: "Настройки",
    settingsIsApplied: "Настройки переданы на устройство",
    settingsIsNotApplied:
        "Настройки сохранены на сервере и будут отправлены устройству в ближайшем сеансе связи",
    share: "Поделиться",
    shareDeviceSettingsTitle: "Поделиться настройками устройства",
    shareSettings: "Поделиться настройками",
    showAll: "Показать все",
    showSideBar: "Показать меню",
    showTelemetry: "Показать данные телеметрии",
    signal: "Уровень сигнала, ASU",
    signIn: "Войти",
    signUp: "Зарегистрироваться",
    sim1pr: "Присутствие SIM 1",
    sim2pr: "Присутствие SIM 2",
    simApn: "APN SIM",
    simApnTooltip: "Имя точки доступа SIM",
    simCard: "Сим-карта",
    simLogin: "Логин SIM",
    simLoginTooltip: "Логин для подключения к точке доступа SIM",
    simPassword: "Пароль SIM",
    simPasswordTooltip: "Пароль для подключения к точке доступа SIM",
    smsFormat: "Формат передачи данных",
    smsFormatSending: "Формат передачи данных по SMS",
    smsFormatTooltip_0: "Ссылка — в SMS передается ссылка на данные",
    smsFormatTooltip_1: "Текст — в SMS передаются данные в текстовом формате",
    smsState: "Передача данных по SMS",
    smsStateTooltip: "Отправлять данные в виде SMS-сообщений",
    sortByAsc: "Сортировать по возрастанию",
    sortByDesc: "Сортировать по убыванию",
    speed: "Скорость",
    statistics: "Статистика",
    stop: "Остановка",
    Stop: "Остановка",
    STOP_DETECT: "Остановка",
    stopdetect: "Остановка",
    subuser: "Пользователь",
    subuserDevicesTitle: "Устройства пользователя",
    subuserRegisterError: "Пользователь с таким логином уже зарегистрирован",
    subusers: "Пользователи",
    support: "Поддержка",
    swVer: "Версия ПО",
    swVerError: "Некорректное значение версии ПО",
    tab: "Вкладка",
    technique: "Оборудование",
    techniqueKind: "Тип оборудования",
    techniqueModel: "Модель оборудования",
    techniqueNumber: "Инвентаризационный номер",
    techSupport: "Тех. поддержка",
    telemetry: "Телеметрия",
    telemetryTime: "Время получения телеметрии",
    temperature: "Температура",
    text: "Текст",
    timeAndDatePickerTitle: "Выберите дату и время",
    timePickerCancel: "Отменить",
    timePickerOk: "Принять",
    timePickerTitle: "Выберите дату и время",
    timerText: "Повторно запросить код подтверждения можно будет через:",
    timeSync: "Синхронизация времени",
    timeSyncGsmState: "Настройка времени по GSM",
    timeSyncGsmStateTooltip:
        "Время устройства корректируется по данным получаемым посредством GSM",
    timeSyncNtpState: "Настройка времени по NTP",
    timeSyncNtpStateTooltip:
        "Время устройства корректируется по данным получаемым от NTP-сервера",
    timeSyncSatsState: "Настройка времени по спутникам",
    timeSyncSatsStateTooltip:
        "Время устройства корректируется по данным получаемым со спутников ГНСС",
    timezone: "Часовой пояс",
    toDate: "До",
    toGenerate: "Сгенерировать",
    topic: "Тема",
    tracker: "Трекер",
    Tracker: "Трекер",
    LightSensorLight: "Датчик света",
    lightsensorlight: "Датчик света",
    LightSensorDark: "Пропадание света",
    lightsensordark: "Появление света",
    Tilt: "Датчик наклона",
    tilt: "Датчик наклона",
    trackMode: "Режим трека",
    trailer: "Прицеп",
    trailerNumber: "Гос. номер",
    trailerVin: "VIN номер",
    type: "Тип",
    unsort: "Не сортировать",
    update: "Обновить",
    updateServer: "Сервер обновлений",
    updateServerAddress: "Адрес сервера обновлений",
    updateServerDir: "Директория файла обновления",
    updateServerFile: "Имя файла обновления",
    updateServerLogin: "Логин сервера обновлений",
    updateServerPassword: "Пароль сервера обновлений",
    updateServerPort: "Порт сервера обновлений",
    uploadFromFile: "Загрузить из файла",
    V: "В",
    value: "Значение",
    VegaMX: "Vega MX",
    visibilitySettings: "Настройки видимости",
    waitForSmsCommand: "Ожидать SMS команды",
    wakeUpTime: "Время пробуждения",
    wakeUpTimeTooltip:
        "Время суток (в соответствии с часовым поясом устройства) в которое устройство выйдет на связь",
    "Wialon IPS 2.0": "Wialon IPS 2.0",
    wrongConfirm: "Неверный код подтверждения",
    wrongContent: "Введите содержание",
    wrongGroupName: "Некорректное имя группы",
    wrongPasswordError: "Неверный пароль",
    wrongTopic: "Введите тему",
    yes: "Да",
    lightSensor: "Датчик света",
    lightSensorIgnoreTime:
        "Время игнорирования датчика света после срабатывания",
    lightSensorIgnoreTimeError:
        "Некорректное время игнорирования света движения после срабатывания",
    lightSensorModesTooltip_0:
        "Отключен — датчик света отключен (устройство не реагирует на освещенность)",
    lightSensorModesTooltip_1:
        "Включен всегда — датчик света включен (при изменении освещенности устройство отправит свои координаты)",
    lightSensorModesTooltip_2:
        "Работает в периоде — датчик света включен в указанный период суток",
    lightSensorPeriodEnd: "Конец периода работы датчика света",
    lightSensorPeriodStart: "Начало периода работы датчика света",
    ignoreLightTimeTooltip:
        "Время в течении которого будет отключен датчик света, после его срабатывания",
    notToIgnoreLightTooltip:
        "Датчик света не отключается после его срабатывания",
    lightModeRising: "Появление света",
    lightModeFalling: "Пропадание света",
    triggeringMode: "Режим срабатывания",
    lightPeriodStartAndEndError:
        "Начало и конец периода работы датчика света не должны быть одинаковыми",
    motionMode: "Датчик движения",
    angleMode: "Датчик наклона",
    motionOrAngle: "Режим датчика",
    sensorModesTooltip: "Режим работы датчика, определять движение или наклон",
    triggerAngle: "Угол срабатывания",
    holdingAngleTime: "Время удержания положения до срабатывания",
    second: "second",
    geozones: "Геозоны",
};

export default RU;
